import axios from "@main/axios";
import statisticTemplate from "@partials/statistic.handlebars";

export class Statistic {
    constructor(el) {
        this.el = el;
        this.tests = Array.from(document.querySelectorAll(".js-test-list"));
        this.url = this.el.dataset.url;
        this.initEvents();
    }

    initEvents() {
        document.addEventListener("refreshStatistic", () => {
            this.refreshStatistic();
        });
    }

    refreshStatistic = async () => {
        try {
            const params = {
                testId: this.getCurrentTestId()
            };
            const response = await axios({
                url: this.url,
                params,
                method: "get",
            });
            if (response?.data?.success && response?.data?.data) {
                if (response.data.data.expire) {
                    this.disableGenerateButton();
                }
                this.el.innerHTML = statisticTemplate({statistic: response.data.data});
            }
        } catch (error) {
            //
        }
    }

    getCurrentTestId() {
        const current = this.tests.filter((test) => test.classList.contains("current"))[0];
        return current.dataset.id;
    }

    disableGenerateButton() {
        const currentTab = this.tests.filter((test) => test.classList.contains("current"))[0];
        let currentButton = currentTab.querySelector(".js-set-test-id");
        currentButton.classList.remove("js-modal-open");
        currentButton.classList.remove("btn--green");
        currentButton.classList.add("btn--dark-gray");
        currentButton.disabled = true;
    }
}

document.querySelectorAll(".js-statistic").forEach(elem => new Statistic(elem));
document.dispatchEvent(new CustomEvent("refreshStatistic"));
